
export const regionIds = ['mx','br','co','cl','vn','pe','th','in','aw','bs'];